import React from 'react';
import moment from 'moment';
import { MasterConfigs } from '../../interfaces/entity';
import { Tag } from 'antd';
import ProfileCard from '../../components/ContactInfo/ProfileCard';
import { constants } from '../../constants/common';

export const leavesConfirg: MasterConfigs = {
  api: () => '/leaves/user/leaves/all',
  title: 'Leaves',
  isActionTab: true,
  modalTitle: (action) => `${action}  Leaves`,
  getColumns: () => {
    return [
      {
        title: 'Months',
        dataIndex: '',
        key: '',
        width: 120,
        align: 'center',
        render: (text, record) => {
          const month = moment(record?.startDate).format('MMM YYYY');
          return {
            children: month,
            props: {
              rowSpan: record?.leaveMonthRowSpan,
            },
          };
        },
      },
      {
        title: 'Leave Date',
        dataIndex: '',
        key: '',
        isSearch: true,
        align: 'center',
        width: 200,
        render: (text, record) => {
          return moment(record?.startDate).format('MMM DD, YYYY') + ' - ' + moment(record?.endDate).format('MMM DD, YYYY');
        },
      },
      {
        title: 'Days',
        dataIndex: 'days',
        key: 'days',
        align: 'center',
        width: 80,
        render: (text) => {
          return <div>
            {text} {text > 1 ? 'days' : 'day'}
          </div>
        }
      },
      {
        title: 'Leave Type',
        dataIndex: 'leaves',
        key: 'leaves',
        width: 150,
        render: (text) => {
          return text?.leaveType?.leaveName;
        },
      },
      {
        title: 'Approvar',
        dataIndex: 'leaveApprovals',
        key: 'leaveApprovals',
        width: 250,
        render: (text) => {
          const approval = text?.approval;
          return <ProfileCard
            size={30}
            name={constants.GET_FULL_NAME(approval)}
            avatarUrl={process.env.FILE_URL + approval?.avatar}
            role={approval?.email}
          />
        },
      },
      {
        title: 'Approval Status',
        dataIndex: 'leaveStatus',
        key: 'leaveStatus',
        width: 150,
        align: 'center',
        render: (text) => {
          return <Tag color={text === 'approved' ? 'green' : text === 'pending' ? 'orange' : 'red'} style={{ textTransform: 'capitalize' }}>{text}</Tag>
        },
      },
      {
        title: 'Leave Reason',
        dataIndex: 'reason',
        key: 'reason',
        isSearch: true,
        width: 300,
        ellipsis: true,
        render: (text) => {
          return text ? text : 'No reason provided';
        },
      },
      {
        title: 'Cancellation Reason',
        dataIndex: 'approvalReason',
        width: 300,
        ellipsis: true,
        key: 'approvalReason',
      }
    ];
  },
  combo: [],
  getData: () => ({}),
};
